import {Text} from '@/components/ui/text/Text'
import styled from 'styled-components'

export const StyledPlannedAccessFrequencyCounter = styled(Text)`
    display: flex;
    align-items: center;
    height: 32px;
`
